"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultStitchingDirectiveOptions = void 0;
exports.defaultStitchingDirectiveOptions = {
    keyDirectiveName: 'key',
    computedDirectiveName: 'computed',
    canonicalDirectiveName: 'canonical',
    mergeDirectiveName: 'merge',
    pathToDirectivesInExtensions: ['directives'],
};
